import { render, staticRenderFns } from "./Dialog_RentalOfTeachingEquipmentForNewStudent.vue?vue&type=template&id=221476fa&"
import script from "./Dialog_RentalOfTeachingEquipmentForNewStudent.vue?vue&type=script&lang=js&"
export * from "./Dialog_RentalOfTeachingEquipmentForNewStudent.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_RentalOfTeachingEquipmentForNewStudent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports